import { defineChain } from 'viem'

export const saakuru = defineChain({
  id: 7225878,
  name: 'Saakuru',
  nativeCurrency: { name: 'Oasys', symbol: 'OAS', decimals: 18 },
  rpcUrls: {
    default: {
      http: ['https://rpc.saakuru.network'],
    },
  },
  blockExplorers: {
    default: {
      name: 'Saakuru explorer',
      url: 'https://explorer.saakuru.network',
      apiUrl: 'https://explorer.saakuru.network/api',
    },
  },
  testnet: false,
})
